/** @type {import('../schema').ProcessDefinition} */
const empleadosTareas = {
  id: "empleados-tareas",
  name: "Tareas de empleados",
  category: "operaciones",
  outcome:
    "Asignar trabajos al personal (limpieza, mantenimiento, ad-hoc) y seguir su ejecución hasta completarse.",
  trigger:
    "El Administrador crea una tarea, o el Sistema la auto-genera tras una reserva de amenity con limpieza.",
  actors: ["Administrador", "Sistema", "Empleado"],
  status: "COMPLETO",
  description:
    "Las tareas (employee_tasks) llegan al empleado por asignación manual del admin o auto-generadas post-reserva de amenity (limpieza). El empleado las avanza pendiente → en_progreso → completada; si se cancela la reserva que la originó, la tarea pasa a cancelada.",
  lanes: [
    { id: "admin", actor: "Administrador" },
    { id: "sys", actor: "Sistema" },
    { id: "emp", actor: "Empleado" },
  ],
  steps: [
    { id: "s1", laneId: "admin", type: "start", label: "Crea y asigna una tarea", description: "Título, descripción, vencimiento y prioridad (alta/media/baja).", evidence: "src/screens/admin/TareasAdmin.jsx" },
    { id: "s2", laneId: "sys", type: "start", label: "Auto-genera tarea post-reserva", description: "Una reserva de amenity con requiresCleaning crea 'Limpieza: {amenity}' (autoGenerated, reservaId).", evidence: "src/screens/Amenities.jsx:469" },
    { id: "s3", laneId: "emp", type: "task", label: "Ve la tarea (pendiente)", description: "El empleado abre su panel y ve las tareas asignadas.", evidence: "src/screens/employee/TareasEmployee.jsx:49" },
    { id: "s4", laneId: "emp", type: "decision", label: "¿La ejecuta o fue cancelada?" },
    { id: "s5", laneId: "emp", type: "task", label: "Inicia y ejecuta (en_progreso)", description: "Marca la tarea en progreso y realiza el trabajo en el edificio.", evidence: "src/screens/employee/TareasEmployee.jsx:74" },
    { id: "s6", laneId: "emp", type: "task", label: "Completa (completada)", description: "Marca completada y se registra completedAt." },
    { id: "s7", laneId: "sys", type: "notification", label: "Refleja el avance al admin", description: "El estado de la tarea queda visible en TareasAdmin." },
    { id: "s8", laneId: "sys", type: "task", label: "Cancela la tarea (cancelada)", description: "Si se cancela la reserva que la originó, la tarea auto-generada se cancela." },
    { id: "s9", laneId: "admin", type: "end", label: "Tarea cerrada" },
  ],
  transitions: [
    { from: "s1", to: "s3" },
    { from: "s2", to: "s3" },
    { from: "s3", to: "s4" },
    { from: "s4", to: "s5", label: "ejecuta" },
    { from: "s4", to: "s8", label: "reserva cancelada" },
    { from: "s5", to: "s6" },
    { from: "s6", to: "s7" },
    { from: "s7", to: "s9" },
    { from: "s8", to: "s9" },
  ],
};

export default empleadosTareas;
